import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';

import { API_URL, apiFetch } from '@/config/api';
import type { VoteAggregatesResponse } from '@/features/votes/vote-aggregates';

export function useVoteAggregates(startTime: string, endTime: string) {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery({
    queryKey: ['vote-aggregates', startTime, endTime],
    queryFn: async (): Promise<VoteAggregatesResponse> => {
      const token = await getAccessTokenSilently();
      const params = new URLSearchParams({
        start_time: startTime,
        end_time: endTime,
      });

      const response = await apiFetch(
        `${API_URL}/admin/vote-aggregates?${params.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.detail?.user_error_message ||
            errorData.detail ||
            'Failed to fetch vote aggregates'
        );
      }

      return await response.json();
    },
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}
